import * as React from 'react';
import { SVGProps } from 'react';

const IconWifiSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.586 7.357A7.835 7.835 0 0 0 8 5.02a7.835 7.835 0 0 0-5.586 2.338L1 5.929a9.888 9.888 0 0 1 3.212-2.168 9.813 9.813 0 0 1 7.576 0A9.895 9.895 0 0 1 15 5.93l-1.414 1.428Z" />
    <path d="M12.241 8.716a6.196 6.196 0 0 0-4.24-1.675 6.196 6.196 0 0 0-4.242 1.675l1.416 1.43A4.212 4.212 0 0 1 8 9.061c1.085 0 2.074.41 2.825 1.085l1.416-1.43ZM9.379 11.607a2.064 2.064 0 0 0-2.757 0L8 13l1.379-1.393Z" />
  </svg>
);
export default IconWifiSizeS;
